import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Box } from "@material-ui/core";
import {
  UnitCardSkeleton,
  VIEW_MODES,
  CustomSelect,
  ViewModeSwitcher,
  BasicTable,
  TableSkeleton,
  UnitCard,
  NoDataFound,
  CustomPagination,
} from "../../../../../../Components";
import { unitTableHeaderData } from "./unitTableHeaderData";
import { UnitsAdvanceSearchTest } from "../../../../../../Services";
import { UnitMapper } from "../../../../UnitsSalesView/UnitMapper";

// Styles
import useStyles from "./styles";

function Units({ propretyId }) {
  const styles = useStyles();
  const [viewMode, setViewMode] = useState(VIEW_MODES.GRID);
  const [isLoading, setIsLoading] = useState(true);
  const [selectType, setSelectType] = useState("Sale");
  const [unitsData, setUnitsData] = useState({
    result: [],
    totalCount: 0,
  });

  const { isDarkMode } = useSelector((state) => state.theme);
  
  const [pagination, setPagination] = useState({
    pageSize: 25,
    pageIndex: 1,
  });
  
  const [inputValue, setInputValue] = useState(pagination.pageIndex);

  const getUnitsData = async () => {
    setIsLoading(true);

    try {
      const body = {
        criteria: {
          propertyId: [{ searchType: 1, value: propretyId }],
        },
        operationType: selectType,
        filterBy: "createdOn",
        orderBy: 2,
      };

      const res = await UnitsAdvanceSearchTest(
        {
          pageIndex: pagination.pageIndex - 1,
          pageSize: pagination.pageSize,
        },
        body
      );

      if (!(res && res.status && res.status !== 200)) {
        const result = ((res && res.result) || [])?.map(
          (item) =>
            item?.unitJson && UnitMapper(item, JSON.parse(item?.unitJson)?.unit)
        );
        setUnitsData({
          result: result,
          totalCount: (res && res.totalCount) || 0,
        });

        setIsLoading(false);
      }
    } catch (err) {
      setUnitsData({
        result: [],
        totalCount: 0,
      });
      setIsLoading(false);
      console.error("Failed to fetch contact:", err);
    }
  };

  const onChangeViewMode = (value) => {
    setViewMode(value);
  };

  const handleSelectedType = async (newValue) => {
    setSelectType(newValue);
  };

  useEffect(() => {
    if (propretyId) {
      getUnitsData();
    }
  }, [propretyId, selectType, pagination]);

  return (
    <Box>
      <Box className={styles.flex}>
        <CustomSelect
          options={[
            { id: "Sale", name: "Sale" },
            { id: "Lease", name: "Lease" },
          ]}
          onValueChange={handleSelectedType}
          varient="defalut"
          disabled={isLoading}
          getOptionLabel={(option) => option.name}
          getOptionValue={(option) => option.id}
          defaultValue={selectType}
          customSelectClasses={styles.customSelect}
        />
        <ViewModeSwitcher
          isLoading={isLoading}
          viewMode={viewMode}
          onChangeViewMode={onChangeViewMode}
        />
      </Box>

      {viewMode === VIEW_MODES.GRID && (
        <Box className={styles.gridContainer}>
          {isLoading ? (
            Array.from({ length: 8 }).map((_, index) => (
              <UnitCardSkeleton index={index} />
            ))
          ) : unitsData?.result?.length > 0 ? (
            unitsData?.result?.map((item) => (
              <UnitCard item={item} selectType={selectType} />
            ))
          ) : (
            <NoDataFound title="units" />
          )}
        </Box>
      )}

      {viewMode === VIEW_MODES.TABLE && (
        <Box>
          {isLoading ? (
            <TableSkeleton rowsNum={12} />
          ) : unitsData?.result?.length > 0 ? (
            <BasicTable
              columns={unitTableHeaderData(isDarkMode, selectType)}
              rowsData={unitsData?.result || []}
              rowHeight={130}
            />
          ) : (
            <NoDataFound title="units" />
          )}
        </Box>
      )}

      <CustomPagination
        totalItems={unitsData.totalCount}
        itemsPerPage={pagination.pageSize}
        currentPage={pagination.pageIndex}
        inputValue={inputValue}
        setInputValue={setInputValue}
        onPageChange={(page) =>
          setPagination((prev) => ({ ...prev, pageIndex: page }))
        }
        onItemsPerPageChange={(items) =>
          setPagination((prev) => ({ ...prev, pageSize: items }))
        }
        isLoading={isLoading}
      />
    </Box>
  );
}

export default Units;
